<template>
	<div class="responsive-note">
		<h3 class="mt-12 font-weight-black">Personalizar Url</h3>
		<v-card class="mt-5 d-flex align-start" width="1219" height="256">
			<div class="rounded borderGreen" style="height: 246px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
			<div class="">
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url Longa</span>
				<span class="d-flex flex-column align-start justify-start">
				<input
					placeholder="Insire a URL longa aqui."
					v-model="urlLong"
					class="mt-3 pl-2 responsive-input" 
					style="border: 2px solid var(--grey-day-020); height: 48px; width: 1120px; margin-left: 40px; margin-right: 20px; border-radius: 4px"
				>
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url Personalizada</span>
				<div class="d-flex align-center mb-6">
					<input
						class="mt-3 pl-2"
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 146px; margin-left: 40px; border-radius: 4px 0 0 4px; border-right:none"
						placeholder="https://emprc.us/"
						disabled
					/>
					<input
						placeholder="Insire a URL longa aqui."
						v-model="short"
						class="mt-3 pl-2 responsive-input-short" 
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 797px; margin-right: 20px; border-radius: 0 4px 4px 0"
					>
					<v-btn
						width="158"
						height="48"
						class="mt-3"
						:disabled="!hasLongShortUrl"
						:style="
							!hasLongShortUrl ? 'background: var(--red); color: var(--white)' : 'background: var(--red); color: var(--white)'"
						@click="customShortUrl"
					>
						<img :src="!hasLongShortUrl ? '../../../../static/images/custom_grey.svg' : '../../../../static/images/custom_white.svg'"/>
						<span class="pl-3 ff">Criar Url</span>
					</v-btn>
				</div>
				</span>
			</div>
		</v-card>

		<transition name="slide">
			<v-card v-if="openEdit" class="mt-5 d-flex align-start" width="1219" height="130">
				<div class="rounded borderGreen" style="height: 120px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
				<div class="">
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Sua Url Customizada</span>
					<span class="d-flex align-center">
						<input
							v-on:focus="$event.target.select()" 
							ref="clone"
							v-model="this.url.shortUrl"
							class="mt-3 d-flex align-center pa-5 responsive-input-response"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
						/>
						<v-btn
							width="150"
							height="48"
							class="mt-2"
							@click="copy"
							color="var(--red)"
						>
							<img src="../../../../static/images/square_white.svg"/>
							<span class="pl-3 ff" style="color: var(--white)">{{copyText}}</span>
						</v-btn>
					</span>
				</div>
			</v-card>
		</transition>
	</div>
</template>
<script>
// Lib
import { mapState, mapActions, mapMutations } from 'vuex'

import VueCookies from 'vue-cookies'

export default {
	data () {
		return {
			urlLong: '',
			short: '',
			customUrl: '',
			copyText: 'Copiar',
			shorterUrl: '',
			openEdit: false,
		}
	},
	computed: {
		...mapState('UrlTools', {
			url: 'url',
			shortUrl: 'shortUrl'
		}),
		hasLongShortUrl () {
			if (this.short !== '' && this.urlLong !== '') {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		...mapActions('UrlTools',{
			customNewtUrl: 'customNewtUrl'
		}),
		...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
		async customShortUrl () {
			const token = VueCookies.get('jwt-login')
			try {
				const urlLongWhiteSpace = this.urlLong.split(' ')
				const urlshortWhiteSpace = this.short.split(' ')
				if (urlLongWhiteSpace.length > 1 || urlshortWhiteSpace.length > 1) {
					this.toaster(
						'URL contém espaço em branco',
						'danger',
						true
					)
					return 
				} else {
					const response = await this.customNewtUrl([
						{
							longUrl: this.urlLong,
							shortUrl: this.short,
						},
						token
					])
					this.openEdit = true
					if (response.status >= 400) {
						throw new Error(response.data.message)
					}  else {
						this.toaster(
							'URL customizada com sucesso',
							'var(--green)',
							true
						)
					}
				}
			} catch (e) {
				this.openEdit = false
        this.toaster(e.message, 'danger', true)
      }
		},
		copy () {
      this.$refs.clone.focus()
      document.execCommand('copy')
    },
		toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
	}
}
</script>
<style lang="">
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-short {
		width: 385px !important;
	}
	.responsive-input-response {
		width: 543px !important;
	}
	.responsive-input {
		width: 710px !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/ShortnerCustom.vue